// vue babel plugin doesn't support pragma replacement
import { mdx } from '@mdx-js/vue'
let h;
/* @jsx mdx */

export const metadata = {
  title: "The Screenwriter's Revenge",
  author: {
    name: "Ryan Cooper",
    githubUsername: "rdc-112"
  },
  created: "2020-09-15T09:00:00Z",
  timeLimit: 45,
  introduction: "You work for a large retailer. Every Friday a charismatic leader sends out a video message to his employees. These videos are uploaded to Microsoft Streams (part of O365). Streams uses machine learning to transcribe videos into text.\n\nOn this particular Friday a window opens on your desktop (just like in a rubbish film from the 90s). The doors around you lock. Shutters drop down (a bit like something from Terminator 2). The window contains the following text:\n\n---Hello valued employee. I am one of your former colleagues. You laughed when I said Sharknado was my favourite film, and sniggered when I described it as a 'tour-de-force'. In order to get my revenge I have scrambled the transcription of this week's video message. The answer to my challenges is the name of a screenplay I am working on which will take Hollywood by storm. If you don't unscramble the message and enter the name of my screenplay within 45 minutes I will make your terminal play Sharknado extremely loudly for the next 6 hours. --- \n\nThe window has a file attached - see the Teams Chat for this meeting for a copy.\n\nLuckily, the transcript is still valid JSON. However some extra characters have been added into some of the words, including some non-English ones, and the entries in the transcription are out of order. \n\nThe hacker has demanded that you enter a phrase by completing the challenges below:",
  finalAnswer: "The Shredderman from Buntingford"
};

const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1>{`Tasks`}</h1>
    <h2>{`Task 1`}</h2>
    <p>{`For each of the first two digits in the total number of words, get the first letter in the film title at the index of that digit in this list:`}</p>
    <p><a parentName="p" {...{
        "href": "https://www.imdb.com/list/ls064202652/"
      }}>{`https://www.imdb.com/list/ls064202652/`}</a></p>
    <p>{`For example: if there were 684 words, the first two digits are 6 and 7.
The films as position 6 and 7 in the list are "Elite Squad 2: The Enemy Within" and "Yogi Bear"
The answer for the first task would therefore be "Elite Yogi".`}</p>
    <h2>{`Task 2`}</h2>
    <p>{`Find the penultimate word from the last element in the array.`}</p>
    <h2>{`Task 3`}</h2>
    <p>{`Find the third word of the second element in the array`}</p>
    <h1>{`Final Puzzle`}</h1>
    <p>{`Please enter your combined solutions from task 1, task 2 and task 3 (separated by a space)`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;

export default {
  name: 'Mdx',
  inject: {
    $mdxComponents: {
      default: () => () => ({})
    }
  },
  computed: {
    components() {
      return this.$mdxComponents()
    }
  },
  render(createElement) {
    h = mdx.bind({ createElement, components: this.components })
    return MDXContent({ components: this.components })
  }
}
   